import { createContext } from "react"

export interface PalmistryContextValue {
  timeLeft: string | null
}

export const PalmistryContext = createContext<PalmistryContextValue>({ timeLeft: null })
